import * as mainTerms from '../../mainTerms';
import {campaign} from './campaign';
import {adset} from './adset';
import {ad} from './ad';
import {audience} from './audience';
import {advertiser} from './advertiser';
import {adFolder} from './adFolder';
const inventoryDef = mainTerms.Setting.inventory.default;

export const form = {
    title: {
        general: '기본 설정',
        inventory: inventoryDef + ' 설정',
        details: '세부 설정',
    },
    campaign,
    adset,
    ad,
    audience,
    advertiser,
    adFolder,
};
